import React from 'react';

const Progress = ({ step, totalSteps }) => (
  <React.Fragment>
    <div className="progress mb-1">
      <div
        className="progress-bar bg-lightblue"
        role="progressbar"
        style={{ width: `${(step / (parseInt(totalSteps) + 1)) * 100}%` }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
    <div className="small text-muted text-center">
      Step {step} of {totalSteps}
    </div>
  </React.Fragment>
);

export default Progress;
